import { render } from "./ViewBill.vue?vue&type=template&id=838f95a4&scoped=true"
import script from "./ViewBill.vue?vue&type=script&lang=js"
export * from "./ViewBill.vue?vue&type=script&lang=js"

import "./ViewBill.vue?vue&type=style&index=0&id=838f95a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838f95a4"]])

export default __exports__